<template>
  <div class="map-container">
    <div :id="this.map_id" class="leaflet-map-container"></div>
    <div
      class="track-legend leaflet-control"
      style="background-color: rgba(22, 35, 54, 0.8)"
      v-if="this.showLegend"
    >
      <h4
        style="
          color: #fff;
          margin-right: 5px;
          margin-left: 5px;
          margin-top: 0px;
        "
      >
        <b>Legend</b>
      </h4>
      <div
        v-for="type in this.legend"
        :key="type.value"
        @click="showOrHideTrackType(type)"
      >
        <dt
          v-bind:class="{ inActive: selected.includes(type.value) }"
          :style="'background:' + type.color"
          style="float: left; width: 10px; height: 10px; margin: 5px"
        ></dt>
        <dd class="white-text">
          {{ type.value.replace("StandUpPaddling", "SUP") }}
        </dd>
      </div>
    </div>
    <!--  <div
      class="map-settings-btn"
      @click="showSettings = true"
      v-if="!showSettings && showMapSelect"
    >
      <right-chevron :color="'#f8ed4b'" :width="32" :height="32" />
    </div>
    <div class="settings-menu" v-if="showSettings">
      <div @click="showSettings = false">
        <close-icon :color="'#FFF'" :width="44" :height="44" />
      </div>
      <h2><span>Map Options</span></h2>
      <div class="options-group">
        <div class="option-group-header">
          <div class="option-group-title">Line</div>
          <div style="height: 100%">
            <right-chevron :color="'#f8ed4b'" :width="32" :height="32" />
          </div>
        </div>
        <div class="option-row">
          <label class="option-label">Line width</label>
          <input
            name="weight"
            type="number"
            min="1"
            max="100"
            v-model="options.lineOptions.weight"
            @change="changeWidth(options.lineOptions.weight)"
          />
        </div>
        <div class="option-row">
          <label class="option-label">Opacity</label>
          <input
            name="opacity"
            type="range"
            min="0"
            max="1"
            step="0.01"
            v-model="options.lineOptions.opacity"
            @change="changeOpacity(options.lineOptions.weight)"
          />
        </div>
        <div class="option-row">
          <label class="option-label">Use heatmap</label>
          <div v-if="this.useHeatmap" @click="changeHeatmap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-check"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              stroke-width="3"
              stroke="#00b341"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 12l5 5l10 -10" />
            </svg>
          </div>
          <div v-else @click="changeHeatmap">
            <close-icon :color="'#FF0000'" :width="32" :height="32" />
          </div>
        </div>
      </div>
      <div class="options-group">
        <div class="option-group-header">
          <div class="option-group-title">Map Design</div>
          <div style="height: 100%">
            <right-chevron :color="'#f8ed4b'" :width="32" :height="32" />
          </div>
        </div>
        <div class="option-row">
          <div style="flex-direction: column">
            <div
              :key="map.name"
              v-for="(map, idx) in this.mapStyles"
              @click="switchTheme(map)"
            >
              <div class="map-label">
                {{ map.display_name }}
              </div>
              <div
                class="map-preview"
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/map-switch-button/' + map.asset),
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
var polyUtil = require("polyline-encoded");
var _ = require("lodash");

import leaflet from "leaflet";

import "leaflet-providers";
import "leaflet-easybutton";

import { activityTypes } from "@/data/activities.js";

const INIT_COORDS = [56.15416876294262, 10.202202488730917];
const DEFAULT_OPTIONS = {
  theme: {
    name: "CartoDB.DarkMatterNoLabels",
    asset: "mapbox-monochrome-100x43.png",
    track_color: "#DAEC12",
  },
  lineOptions: {
    color: "#0CB1E8",
    weight: 1,
    opacity: 0.5,
    smoothFactor: 1,
    overrideExisting: true,
    detectColors: true,
  },
  markerOptions: {
    color: "#00FF00",
    weight: 3,
    radius: 5,
    opacity: 0.5,
  },
};

export default {
  props: {
    map_id: {
      type: String,
    },
    tracks: {
      type: Array,
    },
    color: {
      type: String,
    },
    showMarker: {
      type: Boolean,
      default: false,
    },
    showMapSelect: {
      type: Boolean,
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activitySettings: activityTypes,
      showSettings: false,
      useHeatmap: true,
      selected: [],
      options: DEFAULT_OPTIONS,
      current: 0,
      scrolled: null,
      map: null,
      tileLayer: null,
      layers: [],
      polylines: [],
      zoom: 13,
      themes: [
        {
          value: "default",
          color: "#DAEC12",
        },
        {
          value: "red",
          color: "#D40000",
        },
        {
          value: "blue",
          color: "#0CB1E8",
        },
        {
          value: "green",
          color: "#A6E81D",
        },
        {
          value: "pink",
          color: "#EF2D77",
        },
      ],
      mapStyles: [
        {
          display_name: "CartoDB.DarkMatter",
          name: "CartoDB.DarkMatter",
          asset: "cartodb-darkmatter-map-100x43.png",
        },
        {
          display_name: "CartoDB.DarkMatterNoLabels",
          name: "CartoDB.DarkMatterNoLabels",
          asset: "cartodb-darkmatter-map-100x43.png",
        },
        {
          display_name: "Mapbox Default",
          name: "https://api.mapbox.com/styles/v1/grayriver/ckpx0zw6s059g18nl87dl17zz/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZ3JheXJpdmVyIiwiYSI6ImNrNDg3cGZtczA1b3kzbWxoaWg2aXVrdHoifQ.zsslrJuvU_Cjvzy8kmT0Ww",
          asset: "mapbox-default-100x43.png",
        },
        {
          display_name: "CartoDB.Positron",
          name: "CartoDB.Positron",
          asset: "cartodb-positron-map-100x43.png",
        },
        {
          display_name: "CartoDB.PositronNoLabels",
          name: "CartoDB.PositronNoLabels",
          asset: "cartodb-positron-map-100x43.png",
        },
        {
          display_name: "CartoDB.Voyager",
          name: "CartoDB.Voyager",
          asset: "cartodb-voyager-100x43.png",
        },
        {
          display_name: "CartoDB.VoyagerNoLabels",
          name: "CartoDB.VoyagerNoLabels",
          asset: "cartodb-voyager-100x43.png",
        },
        {
          display_name: "Stamen.Watercolor",
          name: "Stamen.Watercolor",
          asset: "watercolor-map-100x43.png",
        },
        {
          display_name: "Old West",
          name: "https://api.mapbox.com/styles/v1/grayriver/ckiulqgr22zqy19mhgvbyebd7/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZ3JheXJpdmVyIiwiYSI6ImNrNDg3cGZtczA1b3kzbWxoaWg2aXVrdHoifQ.zsslrJuvU_Cjvzy8kmT0Ww",
          asset: "mapbox-old-west-100x43.png",
        },
        {
          display_name: "Monochrome",
          name: "https://api.mapbox.com/styles/v1/lesliex/ckiax2fyd06rh19nzhq6680a8/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic291cGF0dGFjayIsImEiOiJja2tjb2hib2ExMXFxMm5yMXVrbWRjcTUwIn0.w5HPgt53kloF-kkBD8a2eA",
          asset: "mapbox-monochrome-100x43.png",
        },
      ],
    };
  },
  mounted() {
    this.initMap();
    // this.initLayers();
  },
  methods: {
    initMap() {
      this.map = leaflet.map(this.map_id, {
        center: INIT_COORDS,
        zoom: 8,
        preferCanvas: true,
        attributionControl: true,
        zoomControl: false,
      });

      //   this.requestBrowserLocation();

      //zoom the map to the polyline
      if (this.tracks) {
        for (var track in this.tracks) {
          var trk = this.tracks[track];
          this.addTrack(trk);
        }
      }
      // this.animate(polyUtil.decode(this.tracks[0].polyline));

      this.switchTheme(this.options.theme);
    },
    initLayers() {
      //   this.layers.forEach((layer) => {
      //     console.log(layer);
      //   });
    },
    switchTheme(theme) {
      if (this.mapTiles) {
        this.mapTiles.removeFrom(this.map);
      }
      if (theme.name.indexOf("mapbox") != -1) {
        leaflet
          .tileLayer(theme.name, {
            attribution:
              'Map data &copy; <a class="activity-link" href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
          })
          .addTo(this.map);
      }

      if (theme.name !== "No map" && theme.name.indexOf("mapbox") == -1) {
        this.mapTiles = leaflet.tileLayer.provider(theme.name);
        this.mapTiles.addTo(this.map, { detectRetina: true });
      }
    },
    getTrackColor(type) {
      let color = this.activitySettings.filter(
        (item) => item.value.toLowerCase() == type.toLowerCase()
      );
      return color[0].color;
    },
    async addTrack(track) {
      var color = this.color;
      if (track.type != undefined) {
        color = this.getTrackColor(track.type.toLowerCase());
      }
      // console.log(color);
      var latlngs = polyUtil.decode(track.polyline);

      let initialLine = {
        color: color,
        weight: this.options.lineOptions.weight,
      };
      if (this.useHeatmap) {
        initialLine = {
          color: color,
          opacity: 0.5,
          weight: 2,
        };

        this.options.lineOptions.opacity = 0.5;
        this.options.lineOptions.weight = 2;
      }

      let line = leaflet.polyline(latlngs, initialLine).addTo(this.map);

      // this.map.fitBounds(line.getBounds());
      //Omly fit the track if there's one
      if (this.tracks.length == 1) {
        this.map.fitBounds(line.getBounds());
      }
      this.polylines.push(
        Object.assign({
          line,
          visible: true,
          highligted: false,
          type: track.type.toLowerCase(),
        })
      );
    },
    arrayRemove(arr, value) {
      return arr.filter(function (ele) {
        return ele != value;
      });
    },
    showOrHideTrackType(type) {
      if (this.selected.includes(type.value)) {
        this.selected = this.arrayRemove(this.selected, type.value);
      } else {
        this.selected.push(type.value);
      }

      this.polylines.forEach((line) => {
        if (line.type == type.value && line.visible) {
          this.map.removeLayer(line.line); // For hide
          line.visible = false;
        } else if (line.type == type.value && !line.visible) {
          this.map.addLayer(line.line); // For show
          line.visible = true;
        }
      });
    },
  },
  computed: {
    legend() {
      let validTypes = this.activitySettings.filter((act) => act.hasGps);
      let uniqTypes = _.uniqBy(this.tracks, "type").map((item) => item.type);

      let showTypes = validTypes.filter((act) => uniqTypes.includes(act.value));
      showTypes = showTypes.map((x) => ({
        ...x,
        show: true,
      }));

      return showTypes;
    },
  },
};
</script>


<style scoped>
/* Make the leaflet container fill it's parent */
.leaflet-map-container {
  position: relative;
  height: inherit;
  width: inherit;
}

.map-switch-container {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 90px;
  height: 50px;
}

.map-switch-button {
  z-index: 1000;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 10px;
  color: #fff;
  border: 2px solid #cccccc;
  height: 30px;
  width: 60px;
  border-radius: 25px;
  opacity: 0.9;
}

.map-switch-button.ninja {
  background-image: require(
    "@/assets/images/map-switch-button/bw-map-100x43.png"
  );
}

.map-switch-button.trail {
  background-image: require(
    "@/assets/images/map-switch-button/outdoors-map-100x43.png"
  );
}

.map-switch-button.satellite {
  background-image: require(
    "@/assets/images/map-switch-button/satellite-map-100x43.png"
  );
}

.map-switch-button.terrain {
  background-image: require(
    "@/assets/images/map-switch-button/terrain-map-100x43.png"
  );
}

.map-switch-button:hover {
  opacity: 1;
  border-color: #fff;
}

.map-preview {
  flex-direction: column;
  width: 100px;
  height: 44px;
}

.map-label {
  font-family: Gidole;
  margin-right: 15px;
  font-size: 1em;
  color: #fff;
}

/* Route info */
.route-info {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #fff;
  border: 2px solid #cccccc;
  background: rgba(58, 58, 58, 0.8);
  /* width: 95vw; */
  border-radius: 25px;
  opacity: 0.9;
}

.details-info {
  margin-bottom: 5px;
  margin-top: 5px;
  margin-right: 10px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.details-item {
  margin: 5px;
  color: #ffffff;
  text-align: center;
  align-content: center;
  justify-content: center;
}

.settings-button {
  left: 20px;
  top: 10px;
  z-index: 1000;
  cursor: pointer;
  position: absolute;
}

/*
==========================================================================
  #legend
  ==========================================================================
  */

.inActive {
  filter: brightness(20%);
}

.legend h4 {
  text-align: center;
  font-size: 16px;
  margin: 2px 12px 8px;
  color: #777;
}

.legend span {
  position: relative;
  bottom: 3px;
}

.legend i {
  min-width: 45px;
  max-width: 75px;
  height: 18px;
  float: left;
  margin: 0 8px 0 0;
  opacity: 0.7;
}

.legend i.icon {
  background-size: 18px;
  background-color: rgba(58, 58, 58, 0.8);
}

.track-legend {
  margin-bottom: 10px;
  margin-right: 10px;
  position: fixed;
  bottom: 20px;
  right: 0;
}

dd {
  color: #fff;
}

/** MODAL */
.color-selection {
  margin-left: 5px;
}

.color-selection-label {
  width: 75px;
  text-transform: capitalize;
}

.bgColor {
  background-color: #e8eaed;
}

.txt-color {
  color: #000;
}

/** MAP SETTINGS */

.map-settings-btn {
  z-index: 1000;
  cursor: pointer;
  position: absolute;
  left: 0px;
  top: 10px;
  height: 40px;
  color: #fff;
  background-color: #4d4d4d;
  border: 2px solid #4d4d4d;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  opacity: 0.9;
}
.map-settings-btn:hover {
  background-color: #4d4d4d;
  border: 2px solid #daec12;
}

/* Settings menu */
.settings-menu {
  z-index: 10000;
  /* transform: translate3d(0px, 0px, 0px); */
  padding: 10px;
  transform: translateX(0);
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  min-width: 300px;
  background-color: #000;
  overflow: auto;
}

.options-title {
  text-decoration: underline #daec12;
  text-shadow: 0 0 5px #ffffff;
  font-size: 3.025em;
  text-align: center;
  font-family: Gidole;
  color: #fff;
}
.option-group-title {
  text-decoration: underline #daec12;
  font-size: 2.025em;
  font-family: Gidole;
  color: #fff;
  margin-left: 5px;
}

.option-group-header {
  display: flex;
  justify-content: space-between;
}

.option-label {
  font-family: Gidole;
  margin-right: 15px;
  font-size: 1.5em;
  color: #fff;
}

.option-row {
  display: flex;
  padding: 5px 15px 5px 15px;
  justify-content: space-between;
}

.settings-button {
  left: 10px;
  top: 10px;
  z-index: 1000;
  cursor: pointer;
  position: absolute;
}

h2 {
  width: 95%;
  text-align: center;
  border-bottom: 3px solid #daec12;
  line-height: 0.1em;
  margin: 10px 0 20px;
  color: #fff;
  text-shadow: 0 0 5px #ffffff;
  font-family: Gidole;
}

h2 span {
  background: #000;
  padding: 0 10px;
}
</style>